export enum LoginFormType {
  phone,
  email,
  code,
  select,
  accounts
}
